<template>
    <div>
        <div id="dashboard-view">
            <here-map>
                <here-live-track v-if="hasAllRoles(['DeviceView', 'VehicleView', 'DeviceEventView'])"></here-live-track>
            </here-map>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import HereMap from '@/components/maps/here/HereMap'
import HereLiveTrack from '@/components/maps/here/components/HereLiveTrack'

export default {
    name: 'Dashboard',
    components: {
        HereMap,
        HereLiveTrack
    },
    mounted () {
    },
    data () {
        return {
            snapshotDialog: false
        }
    },
    computed: {
        ...mapState([
            'snapshotId'
        ])
    },
    watch: {
        snapshotId: {
            handler (value) {
                if (null !== value) {
                    this.snapshotDialog = true
                }
            },
            deep: true
        }
    },
    methods: {
        dialogClosed ($event) {
            this.snapshotDialog = $event
            this.$store.state.snapshotId = null
        }
    }
}
</script>

<style scoped lang="scss">

</style>
